import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './TimeBillingErrors.scss';
import TimeBillingErrorsDisplay from './TimeBillingErrorsDisplay';

const TimeBillingErrors = ({ errors, warnings }) => {
  const [isErrorTooltipVisible, setIsErrorTooltipVisible] = useState(false);
  const [isWarningTooltipVisible, setIsWarningTooltipVisible] = useState(false);

  // switches tooltip visibility and hides other tooltip if it is visible
  const toggleTooltip = (type) => {
    if (type === 'error') {
      setIsErrorTooltipVisible(!isErrorTooltipVisible);
      if (isWarningTooltipVisible) setIsWarningTooltipVisible(false);
    } else {
      setIsWarningTooltipVisible(!isWarningTooltipVisible);
      if (isErrorTooltipVisible) setIsErrorTooltipVisible(false);
    }
  };

  return (
    <div className='time-billing-errors-container'>
      <p className='time-billing-errors-header'>Time Entry Error</p>
      <div className='time-billing-errors-errorsContainer'>
        { warnings.length > 0 &&
          <TimeBillingErrorsDisplay
            type='warning'
            errorArray={warnings}
            isTooltipVisible={isWarningTooltipVisible}
            setTooltipVisible={setIsWarningTooltipVisible}
            toggleTooltip={() => toggleTooltip('warning')}
          />
        }
        { errors.length > 0 &&
          <TimeBillingErrorsDisplay
            type='error'
            errorArray={errors}
            isTooltipVisible={isErrorTooltipVisible}
            setTooltipVisible={setIsErrorTooltipVisible}
            toggleTooltip={() => toggleTooltip('error')}
          />
        }
      </div>
    </div>
  );
};

TimeBillingErrors.propTypes = {
  errors: PropTypes.array,
  warnings: PropTypes.array,
};

export default TimeBillingErrors;
